/**
 * One glyph from the shared SVG sprite the Razor views use
 * (`wwwroot/icons/sprite.svg`, served by the SharedUI RCL at `/myui`).
 *
 * The views inlined `<svg class="sa-icon"><use href="…sprite.svg#name">` at every
 * call site, and at least one of them got the path wrong — the change-password
 * eye toggle swapped in a relative `icons/sprite.svg#eye-off`, which resolves
 * against the current route and silently blanks the icon. Naming the glyph and
 * building the path in one place removes that whole class of mistake.
 */
export function SpriteIcon({
  name,
  size = 16,
  className = 'sa-icon',
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  return (
    <svg className={className} width={size} height={size} aria-hidden="true">
      <use href={`/myui/icons/sprite.svg#${name}`} />
    </svg>
  );
}
